import React, { useContext } from "react";
import { LanguageContext } from "./LanguageContext";
import classes from "./LanguageSelector.module.css";

const languages = [
  { code: "3", label: "EN" },
  { code: "2", label: "AR" },
];

const LanguageSelector = () => {
  const { lang, setLang } = useContext(LanguageContext);

  const selectLang = (code) => {
    setLang(code);
    // document.body.dir = code === "2" ? "rtl" : "ltr";
    document.body.dir = "ltr";
  };

  
  // const sortedLanguages = [
  //   ...languages.filter(l => l.code === lang),
  //   ...languages.filter(l => l.code !== lang),
  // ];

  return (
    <div className={classes.wrapper}>
      {languages.map((l) => (
        <button
          key={l.code}
          className={`${classes.option} ${
            lang === l.code ? classes.active : ""
          }`}
          onClick={() => selectLang(l.code)}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;